module.exports = __webpack_public_path__ + "static/logo-77130165fc67cc6ad9975e8c272dfd8d.png";